<template>
    <main-container title="Contact Us">
        <div class="row">
            <div class="col-12 col-sm-6 offset-sm-3">
                <div v-if="!online" class="alert alert-danger" role="alert">
                    A network connection is required to contact us!
                </div>

                <div v-if="online">
                    <form @submit.prevent="submit" method="post" novalidate>
                        <div class="form-group">
                            <label for="first-name">First Name</label>
                            <input type="text" class="form-control" id="first-name" v-model="firstName" placeholder="Enter first name">
                        </div>

                        <div class="form-group">
                            <label for="last-name">Last Name</label>
                            <input type="text" class="form-control" id="last-name" v-model="lastName" placeholder="Enter last name">
                        </div>

                        <div class="form-group">
                            <label for="email">Email Address</label>
                            <input type="email" class="form-control" id="email" v-model="email" placeholder="Enter email address">
                            <invalid-feedback :errors="errors" attribute="email" />
                        </div>

                        <div class="form-group">
                            <label for="phone">Phone Number</label>
                            <input type="text" class="form-control" id="phone" v-model="phone" placeholder="Enter phone number">
                        </div>
                        <div class="form-group">
                            <label for="comments">Comments</label>
                            <textarea class="form-control" id="comments" v-model="comments" rows="3"></textarea>
                        </div>

                        <div class="my-3">
                            <vue-recaptcha
                                ref="recaptcha"
                                :sitekey="recaptchaSiteKey"
                                @verify="verifyRecaptcha"
                                @expired="expiredRecaptcha"
                            />
                            <invalid-feedback :errors="errors" attribute="g-recaptcha-response" />
                        </div>
                        <button @click.prevent="submit" type="submit" class="btn btn-primary btn-block" :disabled="submitting">
                            Send Message
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </main-container>
</template>

<script>
import _ from 'lodash'
import VueRecaptcha from 'vue-recaptcha'
import MainContainer from '@/components/main-container'
import InvalidFeedback from '@/components/invalid-feedback'
import Vuex from 'vuex'
import { ajax } from 'jquery'

export default {
    components: {
        InvalidFeedback,
        MainContainer,
        VueRecaptcha,
    },
    data: () => ({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        comments: '',
        gRecaptchaResponse: '',

        submitting: false,
        errors: {},
    }),
    computed: {
        ...Vuex.mapState(['online']),
        ...Vuex.mapGetters(['humanTire', 'calculation']),
        recaptchaSiteKey: () => process.env.VUE_APP_NOCAPTCHA_SITEKEY,
        action: () => '/contact-us',
        postData () {
            return {
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                phone: this.phone,
                comments: this.comments,
                tire: this.humanTire,
                calculation: this.calculation,
                'g-recaptcha-response': this.gRecaptchaResponse,
            }
        },
        valid () {
            let data = [this.email, this.comments, this.gRecaptchaResponse]
            return _.every(data, item => _.trim(_.toString(item)) !== '')
        },
    },
    methods: {
        verifyRecaptcha (response) {
            this.gRecaptchaResponse = response
        },
        expiredRecaptcha () {
            this.gRecaptchaResponse = ''
        },

        submit () {
            this.submitting = true
            this.errors = {}
            ajax(this.action, {
                method: 'post',
                data: this.postData,
                dataType: 'json',
                error: this.failure,
                success: this.success,
                complete: this.complete
            })
        },
        success () {
            this.$router.push({ name: 'contact-success' })
        },
        failure (response) {
            this.$refs.recaptcha.reset()
            this.errors = _.chain(response)
                .get('responseJSON.errors')
                .value()
        },
        complete () {
            this.submitting = false
        }
    },
    created () {
        // this.email = 'jdoe'
        // this.comments = 'This is a comment'
        // this.gRecaptchaResponse = 'test'
    },
}
</script>
